import React, { useState } from 'react';
import styled from 'styled-components';
import SideBar from './SideBar';
import Header from './Header';
import { SCREEN_MAX_WIDTH } from '../../constants/config';

const Wrapper = styled.div`
    position: fixed;
    top: 0;
    width: 100svw;
    min-height: 100svh;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    color: white;
    overflow: hidden;
`
const Col = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;

`
const Main = styled.div`
    display: flex;
    flex-direction: column;
    height: calc(100svh - 4em);
    padding: 1em 1em;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    background: ${({ theme }) => theme.body};
    overflow: hidden;
    overscroll-behavior: contain;
    max-width: 94svw;


    @media (max-width: ${SCREEN_MAX_WIDTH}) {
        max-width: calc(100svw - 2em);
    }
`

export const MenuContext = React.createContext();

const Body = ({ children, ...props }) => {

    const [isOpen, setIsOpen] = useState(false);

    const contextValue = {
        isOpen,
        setIsOpen
    }

    return (
        <MenuContext.Provider value={contextValue}>
            <Wrapper>
                <SideBar />
                <Col>
                    <Header />
                    <Main>
                        {children}
                    </Main>
                </Col>
            </Wrapper>
        </MenuContext.Provider>
    );
}

export default Body;
